import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import TabPanel, { a11yProps } from '@/components/tab-panel/tab-panel';
import OptimizationTestTab from './optimization-test-tab';
import OptimizationCronTab from './optimization-cron-tab';
import BotTestTab from './bot-test-tab';
import BotCronTab from './bot-cron-tab';
import CheckTab from './check-tab';
import ToolsCatalogTab from './tools-catalog-tab';

const TABS = [
  {
    id: 'opt-test',
    label: 'Optimization (test)',
    testId: 'tab-ai-opt-test',
    content: <OptimizationTestTab />,
  },
  {
    id: 'bot-test',
    label: 'Bot (test)',
    testId: 'tab-ai-bot-test',
    content: <BotTestTab />,
  },
  {
    id: 'opt-cron',
    label: 'Optimization (cron)',
    testId: 'tab-ai-opt-cron',
    content: <OptimizationCronTab />,
  },
  {
    id: 'bot-cron',
    label: 'Bot (cron)',
    testId: 'tab-ai-bot-cron',
    content: <BotCronTab />,
  },
  {
    id: 'check',
    label: 'Check',
    testId: 'tab-ai-check',
    content: <CheckTab />,
  },
  {
    id: 'tools-catalog',
    label: 'Tools catalog',
    testId: 'tab-ai-tools-catalog',
    content: <ToolsCatalogTab />,
  },
] as const;

function AiAdmin() {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tab}
          onChange={(_e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="AI admin tabs">
          {TABS.map((t, index) => (
            <Tab
              key={t.id}
              label={t.label}
              {...a11yProps(index)}
              data-testid={t.testId}
            />
          ))}
        </Tabs>
      </Box>
      {TABS.map((t, index) => (
        <TabPanel key={t.id} value={tab} index={index}>
          <Box sx={{ pt: 2 }}>{t.content}</Box>
        </TabPanel>
      ))}
    </Box>
  );
}

export default AiAdmin;
